"use strict";

exports.__esModule = true;
exports.sortStates = void 0;
var statesOrder = ["Producing", "Setup", "Standby", "Planned Downtime", "Unplanned Downtime", "Shutdown", "Data Unavailable"];

// Sort states list into a set order
var sortStates = exports.sortStates = function sortStates(statesArray) {
  var statesOrdered = [];
  var _loop = function _loop(i) {
    if (statesArray.findIndex(function (s) {
      return s.name === statesOrder[i];
    }) > -1) {
      statesOrdered.push(statesArray[statesArray.findIndex(function (s) {
        return s.name === statesOrder[i];
      })]);
    }
  };
  for (var i = 0; i < statesOrder.length; i++) {
    _loop(i);
  }
  return statesOrdered;
};